import React from "react";

export const DashboardIcon = ({
  width = "26.4",
  height = "26.4",
  fill = "#fff",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.4 26.4"
      {...{ width, height }}
    >
      <path
        id="iconmonstr-dashboard-2"
        d="M13.2,2.2a11,11,0,1,1-11,11A11.012,11.012,0,0,1,13.2,2.2Zm0-2.2A13.2,13.2,0,1,0,26.4,13.2,13.215,13.215,0,0,0,13.2,0Zm8.823,10.552a9.845,9.845,0,0,0-.568-1.366l-2.7,1.217a6.787,6.787,0,0,1,.569,1.366ZM8.193,9.558A6.592,6.592,0,0,1,9.2,8.505L7.125,6.34a9.617,9.617,0,0,0-1.01,1.053L8.193,9.558Zm1.886-1.665A6.2,6.2,0,0,1,11.4,7.317L10.26,4.491a9.2,9.2,0,0,0-1.318.576ZM7.044,11.87A6.856,6.856,0,0,1,7.592,10.5L4.875,9.321A9.862,9.862,0,0,0,4.327,10.7ZM17.422,5.05a9.125,9.125,0,0,0-1.32-.571l-1.126,2.83a6.173,6.173,0,0,1,1.32.571Zm2.861,2.343a9.621,9.621,0,0,0-1.01-1.053L17.194,8.505A6.631,6.631,0,0,1,18.2,9.558l2.079-2.165Zm-6.37-3.365C13.672,4.009,13.432,4,13.2,4s-.474.01-.715.029V7.091a6.127,6.127,0,0,1,1.429,0ZM13.2,19.188a2.577,2.577,0,0,1-1.246-4.833L13.2,8.514l1.246,5.84A2.578,2.578,0,0,1,13.2,19.188Z"
      />
    </svg>
  );
};
